<template>
  <div class="page">
    <div class="list" v-if="false">
      <div class="list-center">
        <!-- <img
          src="@/assets/03fc35c92aaf4605442a3105952c9e2c_tianli-logo 3 (2).png"
          alt=""
          @click="goHome"
          style="cursor: pointer"
        /> -->
        <img
          @click="goHome"
          v-complete:src="configObj.top_logo?.value"
          alt=""
        />
        <!-- <p @click="goHome">
          {{ configObj.site_name?.value }}
        </p> -->

        <div class="menu-box">
          <el-menu
            :default-active="mydata.activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            :ellipsis="false"
          >
            <template v-for="item in mydata.menuList" :key="item.id">
              <!-- 具有子级 -->
              <el-sub-menu
                v-if="Array.isArray(item.children)"
                :index="String(item.id)"
                :popper-append-to-body="false"
                :teleported="false"
                popper-class="my-el-sub-menu-popper"
              >
                <template #title>
                  <p @click="menuItemClick(item)">{{ item.title }}</p>
                </template>
                <el-menu-item
                  v-for="item2 in item.children"
                  :key="item2.id"
                  :index="String(item2.id)"
                  @click="menuItemClick(item2)"
                  >{{ item2.title }}</el-menu-item
                >
              </el-sub-menu>
              <!-- 没有子级 -->
              <el-menu-item
                v-else
                :index="String(item.id)"
                @click="menuItemClick(item)"
                >{{ item.title }}</el-menu-item
              >
            </template>
          </el-menu>
        </div>
      </div>
    </div>
    <!--  -->
    <router-view
      class="layout-router-view box1"
      v-if="mydata.menuList.length"
      v-slot="{ Component }"
    >
      <keep-alive :include="mydata.includeArr">
        <component :is="Component" />
      </keep-alive>
    </router-view>

    <!-- 右侧悬浮组件 -->
    <!-- <floatingComponents></floatingComponents> -->
  </div>
</template>

<script setup>
import floatingComponents from "@/components/floatingComponents/index.vue";
import { useRouter, useRoute } from "vue-router";

import { inject, reactive, watch } from "vue";

import { ArrowDown } from "@element-plus/icons-vue";

import { getMenu } from "@/api/list/index.js";
//引入slideShow接口
import { slideShow } from "@/api/slideShow/index.js";
// 目录数组的id值所对应的url跳转地址
import { menuListIdUrl, getUrlId } from "@/utils/slide.js";
//引入学段接口、班级（年级）接口、学科接口、学校类型接口、流程类型接口
import {
  getStage,
  getClasses,
  getSubject,
  getSchoolType,
  getFlowType,
  activityTheme,
  getSearchList,
  getProvinceType,
  examPropertyList,
  bookScreeningCondition,
} from "@/api/dictionary/index.js";
// 引入接口
import { get_grade } from "@/api/login/nowLogin/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  active: "",
  activeIndex: "17", // 这里不能写空字符串，因为它绑定给了default-active（页面加载时默认激活菜单的 index）应该是index下标不能为空字符串吧
  menuList: [], //目录数组
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  // 缓存哪些组件
  includeArr: [
    "addedServices",
    "boutiqueTaobaoQuestions",
    "boutiqueTaobaoQuestions",
    "listenBig",
    "research",
    "teachingActivities",
    "projectAchievements",
    "studentWorld",
    "studentWorldList",
    "KnowledgeDrivenGoods",
    "onlineLearning",
    "thematicActivities",
    "worksDisplay",
    "talkPolicies",
    "parentChildGarden",
    "findAUniversity",
    "checkTheProcess",
    "authorizedOnlineShop",
    "walkIntroTianLi",
    "personalCenter",
    "myDownloads",
    "myCollection",
    'checkTheProcessList',

    "myCollection",
    "myDownloads",
    "myBook",
    "myNotifications",
    "myActivity",
  ],
});

// 监听路由地址
watch(
  () => {
    return route.path;
  },
  (newVal, oldVal) => {
    mydata.activeIndex = getUrlId(newVal);
  },
  { immediate: true }
);

const configObj = inject("configObj");
// console.log('configObj!!!',configObj);

function goHome() {
  router.push({
    path: "/layout/list/home",
  });
}

// 调用getMenu函数（发送请求）
getMenu().then((res) => {
  //发送请求
  slideShow().then((res2) => {
    // 设置本地存储轮播图数组
    localStorage.setItem("slideObj", JSON.stringify(res2.data));
    /* 【等到轮播接口调用完毕之后再给目录数组赋值，让其他页面显示，因为其他页面里面使用了轮播的本地存储】这是目录的内容 start */
    // 赋值
    mydata.menuList = res.data;
    // 过滤
    mydata.menuList = mydata.menuList.filter((item) => {
      return item.type === 1;
    });
    // 排序
    mydata.menuList.sort((prev, next) => {
      return prev.sort - next.sort;
    });
    // 本地存储目录
    localStorage.setItem("menuList", JSON.stringify(mydata.menuList));
    /* 【等到轮播接口调用完毕之后再给目录数组赋值，让其他页面显示，因为其他页面里面使用了轮播的本地存储】这是目录的内容 end */
  });
});

// 目录点击事件
function menuItemClick(menuItem) {
  // 获取跳转地址
  let url = menuListIdUrl[menuItem.id];
  // 如果跳转地址存在
  if (url) {
    // 跳转
    router.push({ path: url });
    // 激活
    mydata.activeIndex = String(menuItem.id);
  }
}

// 获取各种字典
function getDict() {
  // 获取学段
  getStage().then((res) => {
    localStorage.setItem("stage", JSON.stringify(res.data));
    let stage2 = res.data.map((item) => {
      item.name = item.id;
      return item;
    });
    localStorage.setItem("stage2", JSON.stringify(stage2));
  });
  // 获取班级
  getClasses().then((res) => {
    // 后端接口里面没有name字段，但是其他短数据管理里面都有name字段，为了方便使用，给这个数据里面添加一个name字段
    let arr = res.data.map((item) => {
      item.name = item.label;
      return item;
    });
    localStorage.setItem("classes", JSON.stringify(arr));
    let arr2 = res.data.map((item) => {
      item.name = item.id;
      return item;
    });
    localStorage.setItem("classes2", JSON.stringify(arr2));
  });
  // 获取学科
  getSubject().then((res) => {
    let arr = res.data.map((item) => {
      item.name = item.id;
      return item;
    });
    localStorage.setItem("subject", JSON.stringify(arr));
  });
  // 学校类型管理
  getSchoolType().then((res) => {
    let arr = res.data.map((item) => {
      item.name = item.id;
      return item;
    });
    localStorage.setItem("schoolType", JSON.stringify(arr));
  });

  // 流程类型管理
  getFlowType().then((res) => {
    localStorage.setItem("flowType", JSON.stringify(res.data));
  });

  // 活动主题列表
  activityTheme({ apply: "student" }).then((res) => {
    // 后端接口里面没有name字段，但是其他短数据管理里面都有name字段，为了方便使用，给这个数据里面添加一个name字段
    let arr = res.data.map((item) => {
      item.label = item.title;
      item.name = item.id;
      return item;
    });
    localStorage.setItem("theme", JSON.stringify(arr));
  });

  // 省份列表
  getProvinceType().then((res) => {
    // 后端接口里面没有name字段，但是其他短数据管理里面都有name字段，为了方便使用，给这个数据里面添加一个name字段
    let arr = res.data.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });
    localStorage.setItem("provinceType", JSON.stringify(arr));
    let arr2 = res.data.map((item) => {
      return {
        label: item.name,
        name: item.name,
      };
    });
    localStorage.setItem("provinceType2", JSON.stringify(arr2));
  });

  // 授权网店搜索条件列表
  getSearchList().then((res) => {
    let obj = res.data;
    obj.territory = obj.territory.map((item) => {
      return {
        label: item,
        name: item,
      };
    });
    obj.platform = obj.platform.map((item) => {
      item.label = item.store_platform;
      item.name = item.id;
      return item;
    });
    localStorage.setItem("searchList", JSON.stringify(res.data));
  });

  // 条件列表（精品淘题）
  examPropertyList().then((res) => {
    // 后端接口里面没有name字段，但是其他短数据管理里面都有name字段，为了方便使用，给这个数据里面添加一个name字段
    //年级
    let grade_list = res.data.grade_list.map((item) => {
      return {
        label: item.grade,
        name: item.id,
      };
    });
    //学科
    let subject_list = res.data.subject_list.map((item) => {
      return {
        label: item.subject,
        name: item.id,
      };
    });
    //地区
    let address_list = res.data.address_list.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });
    //地区
    let address_list2 = res.data.address_list.map((item) => {
      return {
        label: item.name,
        name: item.name,
      };
    });
    //类型
    let type_list = res.data.type_list.map((item) => {
      return {
        label: item.type,
        name: item.id,
      };
    });
    //年份
    let year_list = res.data.year_list.map((item) => {
      return {
        label: item.year,
        name: item.id,
      };
    });
    //年份2
    let year_list2 = res.data.year_list.map((item) => {
      return {
        label: item.year,
        name: item.year,
      };
    });

    localStorage.setItem("grade_list", JSON.stringify(grade_list));
    localStorage.setItem("subject_list", JSON.stringify(subject_list));
    localStorage.setItem("address_list", JSON.stringify(address_list));
    localStorage.setItem("address_list2", JSON.stringify(address_list2));
    localStorage.setItem("type_list", JSON.stringify(type_list));
    localStorage.setItem("year_list", JSON.stringify(year_list));
    localStorage.setItem("year_list2", JSON.stringify(year_list2));
  });

  // 图书列表的搜索条件
  bookScreeningCondition().then((res) => {
    // 版本
    let book_version_years = res.data.version_years.map((item) => {
      return {
        label: item,
        name: item,
      };
    });
    // 学段
    let book_grade = res.data.grade.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });

    // 学科
    let book_subject = res.data.subject.map((item) => {
      return {
        label: item.name,
        name: item.id,
      };
    });

    localStorage.setItem(
      "book_version_years",
      JSON.stringify(book_version_years)
    );
    localStorage.setItem("book_grade", JSON.stringify(book_grade));
    localStorage.setItem("book_subject", JSON.stringify(book_subject));
  });

  get_grade().then((res) => {
    let gradeIdOptions = res.data;
    localStorage.setItem("gradeIdOptions", JSON.stringify(gradeIdOptions));
  });
}

// 调用方法
getDict();
</script>

<style scoped lang="scss">
.box1 {
  //margin-top: 116px;
  // border:1px solid red;
}
.page {
  width: 100%;
  // min-width:1440px;
}
.list {
  width: 100%;
  min-width: 1440px;
  height: 96px;
  background-color: #ffffff;
  //  background-color: pink;
  display: flex;
  justify-content: center;
  align-items: center;
  // border:1px solid red;
  // margin-top: 18px;
  //position: fixed;
  position: sticky;
  top: 40px;
  z-index: 1000;
  // overflow: hidden;
  // > img {
  //   margin-right: 86px;
  // }
  .list-center {
    width: 1340px;
    //  margin:0 auto;
    // border:1px solid red;
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      // width:50px;
      width: 230px;
      margin-right: 20px;
      cursor: pointer;
    }
    > p {
      // width: 161px;
      font-size: 23px;
      font-weight: 700;
      color: #000000;
      margin-right: 20px;
      cursor: pointer;
      // border:1px solid red;
    }
    .menu-box {
      // border: 1px solid red;
      width: 1088px;
      flex-shrink: 0;
      :deep(.el-menu.el-menu--horizontal.el-menu-demo) {
        border: none;
        justify-content: space-between;
        > .el-menu-item {
          max-width: 108px !important;
        }
        > .el-sub-menu {
          max-width: 132px !important;
        }
      }
      // :deep(.el-menu-item.is-active){
      //   background-color: none;
      // }
      :deep(.el-menu-item) {
        overflow: hidden;
        font-size: 16px;
        font-size: 17px;
        font-weight: 400;
        color: #333333;
      }
      :deep(.el-sub-menu) {
        overflow: hidden;
      }
      :deep(.el-sub-menu__title.el-tooltip__trigger.el-tooltip__trigger) {
        font-size: 16px;
        font-size: 17px;
        font-weight: 400;
        color: #333333;
      }
    }
  }

  // > p {
  //   font-size: 16px;
  //   color: #333333;
  //   margin-right: 26px;
  //   cursor: pointer;
  // }
  // > p:hover {
  //   color: #009de0;
  // }
}
:deep(.my-el-sub-menu-popper) {
  inset: unset !important;
}
// 限制目录子级下拉框的宽度
:deep(.el-menu--popup) {
  min-width: 130px !important;
  // 目录子级文字居中
  .el-menu-item {
    display: block !important;
    text-align: center !important;
  }
}
</style>
